import axios from "axios";
const state = {};
import config from "@/../config";
const defaultErrorHandler = (error) => Promise.reject(error.response);

const mutations = {};

const actions = {
  async INSERT_INSURED({ commit }, payload) {
    delete payload.stepType;
    let response = await axios.post(
      `${config.apiUrl}${config.versoes[0]}/segurado/?documento=${payload.document}`,
      payload.data
    );
    return response.data;
  },
  async UPDATE_INSURED_ADDRESS({ commit }, payload) {
    let response = await axios.put(
      `${config.apiUrl}${config.versoes[0]}/segurado/?documento=${payload.document}`,
      payload.data
    );
    return response.data;
  },
  async GET_INSURED_DATA({ commit }, payload) {
    let apiUrl = "/segurado/?documento=" + payload.document;
    if (payload.name != null) apiUrl += "&nome=" + payload.name;

    let response = await axios.get(config.apiUrl + config.versoes[0] + apiUrl);
    /*if (!response.data[0].ativo) {
      return Promise.reject(response.data);
    }
    if (!response.data.length) {
      return Promise.reject({ response });
    }*/
    return response.data;
  },
  async GET_INSURED_DATA_RAZAOSOCIAL({ commit }, payload) {
    let response = await axios.get(
      config.apiUrl +
        config.versoes[0] +
        "/segurado/?nome=" +
        payload.name +
        "&tipo_pessoa=" +
        payload.personType
    );
    if (!response.data.length) {
      return Promise.reject({ response });
    }
    if (!response.data[0].ativo) {
      return Promise.reject(response.data);
    }
    return response.data;
  },
};

export default {
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/insured.js